import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updatePassword } from "aws-amplify/auth";
import { gosafeApi } from "../../api";
import {
  onLoading,
  onErrorMessage,
  onSuccessMessage,
} from "../../store/secretary/admin";
import { onUpdateUser } from "../../store/auth";
import { translations } from "../../helpers";

export const useAdminStore = () => {
  const dispatch = useDispatch();

  const { isLoading, message } = useSelector((state) => state.admin);

  const startUpdatePassword = useCallback(
    async ({ oldPassword, newPassword, confirmPassword }) => {
      try {
        dispatch(onLoading());

        if (newPassword !== confirmPassword) {
          return dispatch(onErrorMessage("Las nuevas claves deben coincidir"));
        }

        await updatePassword({ oldPassword, newPassword });

        dispatch(onSuccessMessage("La clave ha sido actualizada con exito"));
      } catch (error) {
        dispatch(onErrorMessage(translations[error.message] || error.message));
      }
    },
    [dispatch]
  );

  const startUpdateAdmin = useCallback(
    async (body) => {
      try {
        dispatch(onLoading());

        // console.log("body", body);

        const { data } = await gosafeApi.put(`admin`, body);

        dispatch(onUpdateUser(data));
        dispatch(onSuccessMessage(translations[data.message] || data.message));
      } catch (error) {
        dispatch(
          onErrorMessage(
            translations[error.response.data.message] ||
              error.response.data.message
          )
        );
      }
    },
    [dispatch]
  );

  return {
    // Props
    isLoading,
    message,

    // Methods
    startUpdatePassword,
    startUpdateAdmin,
  };
};
